import { AsyncPipe, NgIf } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { LoaderService } from "app/shared/services/edduca-imob";

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [NgIf, AsyncPipe]
})
export class LoaderComponent implements OnInit {

  constructor(
    public loaderService: LoaderService
  ) { }

  ngOnInit() {
  }

}